import React from 'react';

const IconFacebook: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0445 1.65144V4.98317H15.0631C14.3395 4.98317 13.8516 5.13461 13.5992 5.4375C13.3468 5.74039 13.2206 6.19471 13.2206 6.80048V9.1857H16.9183L16.4261 12.9213H13.2206V22.5H9.35877V12.9213H6.14062V9.1857H9.35877V6.43449C9.35877 4.86958 9.79627 3.65595 10.6713 2.79357C11.5463 1.93119 12.7115 1.5 14.1671 1.5C15.4039 1.5 16.363 1.55048 17.0445 1.65144Z"
      fill="currentColor"
    />
  </svg>
);

export default IconFacebook;
